import gql from 'graphql-tag';
import { query } from 'services/graphql';
import { userDetailsFragment } from 'graphql/user/fragments';

export const fetchLoggedUserQuery = gql`
  query fetchLoggedUser {
    fetchLoggedUser {
      data {
        ...userDetails
      }
      error
    }
  }
  ${userDetailsFragment}
`;

export default query(fetchLoggedUserQuery);
